module.exports = __webpack_public_path__ + "static/media/noHW.d4e51c78.png";